module.exports = __webpack_public_path__ + "static/media/customer.3c96fabf.svg";